import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProjectsComponent } from './projects/projects.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { SignupComponent } from './signup/signup.component';
import { AboutComponent } from './about/about.component';
import { HeroBannerComponent } from './hero-banner/hero-banner.component';
import { NavigationTopComponent } from './navigation-top/navigation-top.component';
import { ViewBookModalComponent } from './view-book-modal/view-book-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalModule } from 'ngx-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer'; // <-- Import PdfViewerModule module
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AppComponent,
    ProjectsComponent,
    ContactComponent,
    FooterComponent,
    SignupComponent,
    AboutComponent,
    HeroBannerComponent,
    NavigationTopComponent,
    ViewBookModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    PdfViewerModule,
    ModalModule.forRoot(),
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [ViewBookModalComponent]
})
export class AppModule { }
